import React from 'react'

const Registration = () => {
  return (
    <div>Registration</div>
  )
}

export default Registration